










































































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import CalendarService from '@services/CalendarService'
import CalendarUtils from '@utils/calendar'
import MiniCalendar from '@ui/Calendar/MiniCalendar'
import ActivationPlanInCartWrapper from '@ui/Campaign/pipeline/EventFeed/activation/ActivationPlanInCartWrapper'
import ActivationRangeWrapper from '@ui/Campaign/pipeline/EventFeed/activation/ActivationRangeWrapper'
import NoActivationDatesDisplay from '@ui/Campaign/pipeline/EventFeed/activation/NoActivationDatesDisplay'

settings =
  name: 'CampaignAudienceListingPricingBox'

  vue:
    props: ['audienceListing', 'segment', 'lineItem', 'campaign', 'activationPlan', 'actions']

    components: {
      MiniCalendar,
      ActivationPlanInCartWrapper,
      ActivationRangeWrapper,
      NoActivationDatesDisplay,
    }

    computed:
      hasAvailableDates: ->
        !!@activationPlan?.available_dates?.length

      isListingInCart: ->
        !!@lineItem

      keyForMiniCalendar: ->
        "mini-calendar-#{@isListingInCart}-#{@hasAvailableDates}"

      engagementCapacity: ->
        capacity = @audienceListing.engagement_capacity[@segment]
        capacity ||= @audienceListing.engagement_capacity['default']
        capacity

      dailyCapacity: ->
        capacity = @engagementCapacity?.sampling_capacity?.daily if @campaignHasSampling
        capacity ||= @engagementCapacity?.reach?.daily if @campaignHasOnsite
        capacity
      defaultCapacity: ->
        capacity = @engagementCapacity?.sampling_capacity?.default if @campaignHasSampling
        capacity ||= @engagementCapacity?.reach?.default if @campaignHasOnsite
        capacity

      campaignHasSampling: -> @campaign.creatives.product_sampling?
      campaignHasOnsite: -> @campaign.creatives.onsite_space?

      segmentsList: ->
        segments = []
        for key, space of @audienceListing.spaces
          creative = @campaignCreativeForSpace space, @campaign.creatives
          segments.push space.segment if creative
        segments

      activationScheduleTableData: ->
        return [] unless @lineItem
        [
          {
            audienceListing: @ctxAudienceListing(@lineItem),
            segment: @lineItem.segment,
            ...@lineItem,
          }
        ]

      optionsForCalendar: ->
        options = 
          selectable: false
          dayCellClassNames: @dayCellClassNames
          eventContent: @eventContent
          eventClick: @hiClickCalendarEvent
        options.initialDate = @options.initialDate if @options?.initialDate
        options.initialDate ||= new Date(@activationPlan.available_dates[0].starts_on) if @hasAvailableDates
        options.initialDate ||= new Date()
        options

      actionsForActivationRange: ->
        addToCartTrigger: @addToCartTrigger
        requestForMoreInfoTrigger: @actions.requestForMoreInfoTrigger

      actionsForActivationInCart: ->
        editActivationPlan: @actions.editActivationPlan
        removeFromCartTrigger: @actions.removeFromCartTrigger
        requestForMoreInfoTrigger: @actions.requestForMoreInfoTrigger

    methods:
      hiClickCalendar: (jsEvent) ->
        @editActivationPlan() if jsEvent.target.closest('.fc-view')

      hiClickCalendarEvent: (ev) ->
        ev.jsEvent.stopPropagation()
        @editActivationPlan()

      addToCartTrigger: -> 
        @actions.addToCartTrigger @audienceListing.id, @segment

      editActivationPlan: ->
        @actions.editActivationPlan @audienceListing, @segment if @isListingInCart

      tableRowClassName: ({ row: lineItem }) ->
        isSameListing = @audienceListing.id is @ctxAudienceListing(lineItem).id
        isSameSegment = lineItem.segment is @segment
        return 'selected' if isSameListing && isSameSegment
        ''

      dayCellClassNames: ({ date, isPast, ...args }) ->
        classes = []

        if !isPast and @activationPlan
          dateIsInPlan = @activationPlan.available_dates.some(({ starts_on }) -> dayjs(starts_on).isSame(date))

          if dateIsInPlan
            classes.push 'planned' if @isListingInCart
            classes.push 'unplanned' unless @isListingInCart

        classes.push 'fc-day-disabled' if !classes.length
        classes

      capacityForDay: (dateStr) ->
        dayOfWeek = CalendarService.shortWeekdayForDate dateStr
        monthAndDay = dayjs(dateStr).format('M-D')
        monthDay = dayjs(dateStr).format('D')
        
        capacity = @dailyCapacity?[dateStr]
        capacity ||= @dailyCapacity?["last_day_of_month"] if CalendarUtils.weekOrdinality(dateStr).isLastDay
        capacity ||= @dailyCapacity?[monthAndDay]
        capacity ||= @dailyCapacity?[monthDay]
        capacity ||= @dailyCapacity?[dayOfWeek]
        capacity ||= @defaultCapacity?.daily
        # capacity ||= @defaultCapacity.weekly / 7 # 7 has to be number of days on week
        Math.ceil capacity

      eventContent: ({ event }, createElement) ->
        capacity = @capacityForDay event.startStr
        return '' unless capacity
        { html: "<div class='absolute right-0 bottom-0 p-1 text-grey-darkest text-xxs'><i class='fas fa-user mr-1 opacity-35'></i><span class='font-bold'>#{capacity}</span></div>"}

      formatDatesForLineItem: (lineItem) ->
        { formatDate } = @$options.filters
        startDate = formatDate(lineItem.available_dates[0].starts_on)
        endDate = formatDate(lineItem.available_dates[lineItem.available_dates.length - 1].starts_on)
        return startDate if startDate is endDate
        "#{startDate} - #{endDate}"

export default VueOptions.vue settings
